<template>
	<div
		class="ld-select con-select"
		:class="{ 'ld-select--disabled': disabled }"
	>
		<label v-if="label" for="" class="vs-select--label">{{ label }}</label>

		<div class="input-select-con">
			<input
				:disabled="disabled"
				autocomplete="off"
				:ref="name"
				@click="disabled ? () => {} : setIsShow(true)"
				@input="searching"
				:readonly="!search"
				:class="{
					'is-custom-icon': icon && iconPack,
					'placeholder--disabled': disabled
				}"
				v-model="placeholder"
				class="placeholder input-select vs-select--input"
			/>

			<input
				autocomplete="off"
				:id="name"
				type="hidden"
				:name="name"
				v-model="selected"
			/>

			<div v-if="icon && iconPack">
				<i
					class="vs-icon icon-scale vs-input--icon feather icon-search icon-after"
				></i>
			</div>

			<div class="container-icons" v-else>
				<i
					v-show="isShow"
					class="material-icons icon-select-clear vs-select--icon "
					:class="{ 'button-clear-show': isShow }"
				>
					close
				</i>
				<!-- <i type="button"  class="icon-select-clear vs-select--icon-clear">
                </button> -->

				<i v-show="!isShow" class="vs-select--icon material-icons">
					keyboard_arrow_down
				</i>
			</div>

			<div
				:id="id"
				v-show="isShow"
				class="vs-select--options vs-select-primary mt-2"
			>
				<ul
					:class="{
						'hide-scroll': !isSearch && listData && !listData.length
					}"
				>
					<li
						v-show="!isSearch"
						:key="index"
						v-for="(item, index) in listData"
						data-text
						class="vs-component"
						:class="selectName"
					>
						<button
							:disabled="item.value === null || item.value === undefined || item.disabled"
							type="button"
							@click="select(item)"
							name="button"
							class="vs-select--item animated fadeIn faster"
							:class="{ selected: selected === item.value }"
						>
							<span>{{ item.text }}</span>
						</button>
					</li>

					<li
						class="no-data"
						v-show="!isSearch && listData && !listData.length"
					>
						<span class="vs-select--item animated fadeIn faster">
							{{ textWhenEmpty }}
						</span>
					</li>

					<li v-show="isSearch" class="vs-component">
						<span class="vs-select--item animated fadeIn faster">
							Buscando...
						</span>
					</li>
				</ul>

				<div
					class="vs-component vs-select--loading"
					:class="{ show: isLoading && !isSearch }"
				>
					<h5>
						Carregando...
					</h5>
				</div>

				<div v-show="isSearch" class="loading"></div>
			</div>
		</div>
		<span></span>
	</div>
</template>

<script>
import CryptoJS from "crypto-js";

export default {
	name: "LdSelect",
	props: {
		model: {
			required: true
		},
		label: String,
		name: String,
		iconPack: String,
		icon: String,
		list: Array,
		search: Function,
		moreData: Function,
		changed: Function,
		listSize: {
			type: Number,
			default: 20
		},
		parent: {
			type: String,
			default: "#main"
		},
		maxWidth: {
			type: String
		},
		textWhenEmpty: {
			type: String,
			default: "Nenhum registro encontrado."
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			wait: null,
			isShow: false,
			searchList: null,
			currentPage: 1,
			isMaxPage: false,
			isLoading: false,
			isToGet: false,
			isSearch: false,
			lastSearchValue: null,
			placeholder: null,
			id: null
		};
	},
	computed: {
		offset() {
			return this.listSize * this.currentPage;
		},
		selected: {
			get() {
				return this.model;
			},
			set(value) {
				this.$emit("update:model", value);
				this.cleanSpanError();
			}
		},
		listData: {
			get() {
				if (this.searchList) {
					return this.searchList;
				}
				return this.list;
			},
			set(value) {
				this.searchList = value;
				this.$emit("update:list", value);
			}
		},
		selectName() {
			return "select" + this.name + "option";
		}
	},
	methods: {
		setId() {
			const randomWord = CryptoJS.lib.WordArray.random(32).toString();

			this.id = "select-options-id" + randomWord;
		},
		repositionSelect($selectParent, $elementParent) {
			const $selectElement = document.querySelector("#" + this.id);

			const waitSelectOptions = setInterval(() => {
				if ($selectElement.toffsetParent !== null) {
					clearInterval(waitSelectOptions);

					if ($selectElement && $selectParent && $elementParent) {
						const parentCoordinates = $selectParent.getBoundingClientRect();

						const parentOffsetLeft = parentCoordinates.left;

						const parentOffsetHeight = parentCoordinates.height;
						const parentOffsetBottom = parentCoordinates.bottom;

						const selectElementCoordinates = $selectElement.getBoundingClientRect();

						const selectOffsetLeft =
							selectElementCoordinates.left;

						const selectOffsetTop = selectElementCoordinates.top;
						const selectOffsetHeight =
							selectElementCoordinates.height;

						const elementParentCoordinates = $elementParent.getBoundingClientRect();

						let top =
							parentOffsetBottom +
							$elementParent.scrollTop -
							elementParentCoordinates.top;
						let left =
							parentOffsetLeft +
							$elementParent.scrollLeft -
							elementParentCoordinates.left;

						if (
							top + selectOffsetHeight >
							elementParentCoordinates.height
						) {
							const offsetTop =
								top -
								10 -
								selectOffsetHeight -
								parentOffsetHeight;

							if (offsetTop - $elementParent.scrollTop > 0) {
								top = offsetTop;
							}
						}

						if (selectOffsetTop !== top) {
							$selectElement.style.top = top + "px";
						}

						if (selectOffsetLeft !== left) {
							$selectElement.style.left = left + "px";
						}

						$selectElement.style.position = "absolute";
						$selectElement.style.opacity = 1;
					}
				}
			}, 1);
		},
		createElementOptions() {
			const $placeholder = this.$el.querySelector(".placeholder");
			const $vsSelectOptions = document.querySelector("#" + this.id);
			const $elementParent = document.querySelector(this.parent);

			if (
				$vsSelectOptions &&
				$vsSelectOptions.style.display === "none" &&
				$placeholder
			) {
				const placeholderCoordinates = $placeholder.getBoundingClientRect();

				$vsSelectOptions.style.minWidth =
					placeholderCoordinates.width + "px";

				if (this.maxWidth == "target") {
					$vsSelectOptions.style.maxWidth =
						placeholderCoordinates.width + "px";
				} else if (this.maxWidth) {
					$vsSelectOptions.style.maxWidth = this.maxWidth;
				}

				$vsSelectOptions.style.opacity = 0;

				if ($vsSelectOptions.parentElement !== $elementParent) {
					document
						.querySelector(this.parent)
						.appendChild($vsSelectOptions);
				}

				this.repositionSelect($placeholder, $elementParent);
			}
		},
		setPlaceholder() {
			if (this.model !== undefined && this.model !== null) {
				let value = "";

				this.listData.forEach(item => {

					if (item && item.value === this.model) {
						value = item.text;
					}
				});

				if (value === "" && typeof this.model === "string") {
					value = this.model;
				}

				this.placeholder = value;
			}
		},
		cleanSpanError() {
			try {
				const input = document.querySelector(`#${this.name}`);
				const spanError = input.parentNode.querySelector(".ld-alert");

				if (spanError) {
					spanError.remove();
				}
			} catch (error) {
				console.error(error);
			}
		},
		setIsMaxPage(count) {
			this.isMaxPage = this.listSize * this.currentPage >= count;
		},
		setIsShow(value) {
			this.isShow = value;
			if (value) {
				this.createElementOptions();
			}
		},
		select(item) {
			this.placeholder = item.text;
			this.selected = item.value;

			if (this.changed) {
				this.changed(item);
			}
		},
		searching(event) {
			let value = event.target.value;
			const self = this;

			if (!this.isShow) {
				this.setIsShow(true);
			}

			if (value && typeof value === "string") {
				value = value.trim();
			}

			// if (!this.lastSearchValue && !value) {
			//     return null;
			// }

			this.lastSearchValue = value;
			this.currentPage = 1;
			this.isMaxPage = false;

			if (this.wait) {
				clearTimeout(this.wait);
			}

			if (value === "") {
				this.placeholder = "";
				this.selected = "";
			}

			this.wait = setTimeout(async () => {
				try {
					this.isSearch = true;

					const data = await self.search(value);

					if (data.length) {
						self.listData = data;
					} else {
						self.listData = [
							{
								text: "Nenhum registro encontrado",
								value: "",
								disabled: true
							}
						];
					}

					setTimeout(() => {
						this.isSearch = false;
					}, 700);
				} catch (error) {
					// if (error["response"] && isStatus401Or403(error.response)) {
					//     return tokenInvalidGuard(error.response, this.$router);
					// }

					if (error && error.message === "Network Error") {
						setTimeout(() => {
							this.searching(event);
						}, 500);

						return null;
					} else {
						self.listData = [
							{
								text: "Nenhum registro encontrado",
								value: "",
								disabled: true
							}
						];

						setTimeout(() => {
							this.isSearch = false;
						}, 700);
					}
				}
			}, 500);
		},
		async endOfScroll(event, isRetry) {
			const $target = event.target;

			let isToGet =
				$target.scrollTop + $target.offsetHeight >
					$target.scrollHeight - ($target.scrollHeight * 40) / 100 &&
				$target.scrollTop + $target.offsetHeight < $target.scrollHeight;

			// const isEnd =
			// 	$target.scrollHeight ===
			// 	$target.scrollTop + $target.offsetHeight;

			if (isRetry) {
				isToGet = isRetry;
			}

			if (isToGet && !this.isLoading && !this.isSearch) {
				if (!this.isMaxPage) {
					try {
						this.isLoading = true;
						this.isToGet = true;

						const params = {
							limit: this.listSize,
							offset: this.offset
						};

						if (this.lastSearchValue) {
							params["search"] = this.lastSearchValue;
						}

						const { data, count } = await this.moreData(params);

						this.setIsMaxPage(count);

						if (this.isMaxPage) {
							this.isLoading = false;
							this.isToGet = false;
							return null;
						}

						this.listData = [...this.listData, ...data];
						this.currentPage += 1;
						this.setIsMaxPage(count);

						setTimeout(() => {
							this.isLoading = false;
						}, 50);
					} catch (error) {
						// if (error["response"] && isStatus401Or403(error.response)) {
						//     return tokenInvalidGuard(error.response, this.$router);
						// }

						if (error && error.message === "Network Error") {
							setTimeout(async () => {
								this.isLoading = false;
								await this.endOfScroll(event, true);
							}, 500);

							return null;
						} else {
							setTimeout(() => {
								this.isLoading = false;
							}, 50);
						}
					} finally {
						this.isToGet = false;
					}
				} else {
					this.isLoading = false;
				}
			}
		},
		hide(event) {
			const $label = this.$el.querySelector(".placeholder");
			const self = this;

			if (event.target !== $label) {
				self.setIsShow(false);
			}
		},
		showListInfocus() {
			if (this.$el) {
				const $inputPlaceholder = this.$el.querySelector(
					".placeholder"
				);

				if ($inputPlaceholder) {
					$inputPlaceholder.addEventListener("focus", () => {
						this.setIsShow(true);
					});
				}
			}
		}
	},
	watch: {
		isShow() {
			this.searchList = null;
		},
		model() {
			this.selected = this.model;
			this.setPlaceholder();

			if (this.model === null || this.model === undefined) {
				this.placeholder = "";
			}

			if (this.changed) {
				const item = this.listData.find(
					item => item.value === this.selected
				);
				this.changed(item);
			}
		},
		list() {
			if (!this.placeholder) {
				this.setPlaceholder();
			}
		}
	},
	beforeMount() {
		this.setId();
	},
	beforeDestroy() {
		const $vsSelectOptions = document.querySelector("#" + this.id);
		if ($vsSelectOptions) {
			$vsSelectOptions.remove();
		}
	},
	mounted() {
		this.setPlaceholder();

		if (!!this.moreData && this.$el) {
			const $listOptions = this.$el.querySelector("ul");
			$listOptions.addEventListener("scroll", this.endOfScroll);
		}

		this.showListInfocus();
		window.addEventListener("click", this.hide);
	}
};
</script>

<style lang="scss">
.ld-select {
	width: auto !important;

	.is-custom-icon {
		padding: 0.7rem 3rem 0.7rem 1rem !important;
	}

	.placeholder {
		display: flex;
		width: 100% !important;
		height: 38px;
		padding-top: 0px !important;
		padding-bottom: 0 !important;
		cursor: pointer;
		font-weight: 500;
		font-family: "Montserrat", sans-serif;

		& p {
			max-width: 95%;
			pointer-events: none;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		&:focus {
			cursor: text;
		}

		&[readonly="readonly"] {
			cursor: pointer;
		}

		&.placeholder--disabled {
			background: #fdfdfd;
		}
	}

	.disabled {
		pointer-events: none;
		height: 60px;
	}

	.container-icons {
		position: absolute;
		right: 0;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		height: inherit;
		padding: 12px 5px;
		pointer-events: none;

		.vs-select--icon {
			position: relative !important;
			transform: translateY(0);
			right: 0;
		}
	}

	.icon-select-clear {
		width: auto;
		height: auto;
	}

	.button-clear-show {
		opacity: 1 !important;
		visibility: visible;
		transform: translateY(-50%) rotate(0);
		transition: transform 0.2s;
	}
}

.vs-select--options {
	position: fixed;
	transition: all .05 ease;

	ul {
		position: relative;
		max-height: 160px;

		&.hide-scroll {
			overflow: hidden !important;
		}

		.no-data {
			pointer-events: none;

			span {
				text-transform: none !important;
			}
		}

		.vs-select--item {
			min-height: 32px;
			font-family: "Montserrat", sans-serif;

			&.selected {
				background: #f5f5f5;

				span {
					font-weight: bold;
				}
			}

			&[disabled="disabled"] {
				cursor: default;
				background: transparent !important;
			}
		}
	}

	.vs-select--loading {
		height: 0;
		overflow: hidden;
		transition: height 0.03s linear;

		&.show {
			height: 23px !important;
		}

		h5 {
			display: block;
			font-size: 12px;
			text-align: center;
			line-height: 23px;
		}
	}

	.loading {
		position: absolute;
		width: 100%;
		top: 50%;
		left: 0;
		transform: translateY(-50%);

		.con-vs-loading {
			position: absolute !important;
			flex-direction: column-reverse;
			top: 0;
		}

		h4 {
			font-size: 1rem;
		}
	}
}
</style>
